import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
    positionAnchor: "revert",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  logsContainer: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "transparent",
    boxShadow: "none",
    padding: "24px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 2,
    flexWrap: "wrap",
    marginBottom: "24px",
  },
  sectionTitle: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    fontSize: 20,
    marginBottom: "4px",
  },
  subTitleText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    paddingY: "48px",
  },
  noItemsText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  logsListContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  logCard: {
    padding: "16px",
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  logCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1,
    flexWrap: "wrap",
    marginBottom: "8px",
  },
  logHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  logIcon: {
    color: colorsConstants.primaryText,
  },
  logIdText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
  },
  logCreatedAtText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
    fontSize: 14,
    marginBottom: "12px",
  },
  logText: {
    color: colorsConstants.primaryText,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
    flexWrap: "wrap",
    marginTop: "24px",
  },
  paginationText: {
    color: colorsConstants.primaryText,
    fontWeight: 600,
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
